export const useDeepClone = (object: any) => {
  return JSON.parse(JSON.stringify(object));
}
